module.exports = __webpack_public_path__ + "assets/img/NPC020.6fbf12fa.png";